import { Outlet, NavLink } from "react-router-dom";

const AdminLayout = () => {

  const tabs = [
    { name: "Service Master", path: "/admin/services" },
    { name: "User Management", path: "/admin/users" },
    { name: "Roles", path: "/admin/roles" },
    { name: "Permissions", path: "/admin/permissions" }
  ];

  return (
    <div className="p-6 bg-slate-50 min-h-full">

      {/* Admin Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-black text-slate-900">
          Administration
        </h1>
        <p className="text-sm text-slate-500">
          Configure services, workflows and system controls.
        </p>
      </div>

      {/* Admin Navigation */}
      <div className="mb-6 border-b border-slate-200 flex gap-6">
        {tabs.map(tab => (
          <NavLink
            key={tab.name}
            to={tab.path}
            className={({ isActive }) =>
              `pb-2 text-sm font-semibold transition ${
                isActive
                  ? "text-indigo-600 border-b-2 border-indigo-600"
                  : "text-slate-400 hover:text-indigo-600"
              }`
            }
          >
            {tab.name}
          </NavLink>
        ))}
      </div>

      {/* Admin Content */}
      <Outlet />

    </div>
  );
};

export default AdminLayout;
